var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sortable-table-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.label))]), _c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.top",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "sortable-table-header__button",
    class: {
      'sortable-table-header__button--active': _vm.direction
    },
    attrs: {
      "type": "button",
      "aria-label": _vm.sortLabel,
      "title": _vm.sortLabel
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('sort');
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": _vm.sortIcon,
      "aria-hidden": "true"
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }